export default "__VITE_ASSET__omz$AYim__"